import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../util/getCustomColor";

const defaultBoxShadow = "inset 0px -1px 0px #f0f0f0";

interface WrapperProps {
  backgroundColor?: string;
  hasBoxShadow?: boolean;
}
export const Wrapper = styled("div")(
  ({ backgroundColor = colors.gray25, hasBoxShadow = true }: WrapperProps) => ({
    height: 64,
    boxShadow: hasBoxShadow ? defaultBoxShadow : "none",
    backgroundColor: getBrandCustom("subHeaderBackgroundColor", backgroundColor),

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    padding: "0 2rem",

    "@media screen and (max-width: 435px)": {
      padding: hasBoxShadow ? "0 2rem" : "0 1rem",
    },
  })
);

export const ChildrenGrid = styled(Grid)(() => ({
  padding: "0 1rem",
  "@media screen and (max-width: 430px)": {
    padding: 0,
  },
}));

interface WrapperProps {
  backgroundColor?: string;
  hasBoxShadow?: boolean;
}
export const WrapperComponentWithChild = styled(Grid)(
  ({ backgroundColor = colors.gray25, hasBoxShadow = true }: WrapperProps) => ({
    height: "100%",
    width: "100%",
    backgroundColor,
    boxShadow: hasBoxShadow ? defaultBoxShadow : "none",
  })
);

export const Title = styled("span")(() => ({
  font: "600 18px/24px Manrope",
  color: getBrandCustom("primaryColor", "#38cfc4"),

  "@media screen and (max-width: 435px)": {
    fontSize: "1rem",
  },
}));
